import { createTheme } from '@material-ui/core'

export const theme = createTheme({
  typography: {
    h1: {
      fontFamily: 'Share Tech Mono, monospace',
    },
    h2: {
      fontFamily: 'Share Tech Mono, monospace',
    },
    body1: {
      fontFamily: 'Share Tech Mono, monospace',
    },
    body2: {
      fontFamily: 'Roboto Mono, monospace',
    },
  },
})
